import { render, staticRenderFns } from "./research.vue?vue&type=template&id=c8062440&scoped=true&lang=pug&"
import script from "./research.vue?vue&type=script&lang=ts&"
export * from "./research.vue?vue&type=script&lang=ts&"
import style0 from "./research.vue?vue&type=style&index=0&id=c8062440&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8062440",
  null
  
)

export default component.exports